"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Application.module.css"));
var react_1 = require("react");
var ApplicationInformation_1 = require("./parts/ApplicationInformation");
var SignatureBox_1 = require("./parts/SignatureBox");
var Education_1 = require("./parts/Education");
var HealthHistory_1 = require("./parts/HealthHistory");
var Transportation_1 = require("./parts/Transportation");
var WorkHistory_1 = require("./parts/WorkHistory");
var MilitaryService_1 = require("./parts/MilitaryService");
var CriminalBackground_1 = require("./parts/CriminalBackground");
var Program_1 = require("./parts/Program");
var EmergencyContacts_1 = require("./parts/EmergencyContacts");
var mobx_react_1 = require("mobx-react");
var Application = (function (_super) {
    __extends(Application, _super);
    function Application(props) {
        var _this = _super.call(this, props) || this;
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Application.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    Application.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                return [2];
            });
        });
    };
    Application.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction(this.constructor.name);
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    Application.prototype.render = function () {
        var model = this.props.model;
        console.log("RENDER Application:");
        console.log(JSON.stringify(this.json_data));
        return (React.createElement("div", null,
            React.createElement("div", { className: "gray-line" }),
            React.createElement("header", { className: styles.header },
                React.createElement("h1", null, "Academy for Nursing and Health Ocupations Application Form")),
            React.createElement(ApplicationInformation_1.ApplicationInformation, { model: model }),
            React.createElement(HealthHistory_1.HealthHistory, { model: model }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(Education_1.Education, { model: model }),
            React.createElement(Transportation_1.Transportation, { model: model }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(WorkHistory_1.WorkHistory, { model: model }),
            React.createElement(MilitaryService_1.MilitaryService, { model: model }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(CriminalBackground_1.CriminalBackground, { model: model }),
            React.createElement(Program_1.Program, { model: model }),
            React.createElement(EmergencyContacts_1.EmergencyContacts, { model: model }),
            React.createElement(SignatureBox_1.SignatureBox, { model: model })));
    };
    Application = __decorate([
        mobx_react_1.observer
    ], Application);
    return Application;
}(react_1.Component));
exports.Application = Application;
//# sourceMappingURL=data:application/json;base64,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